"use strict";
// @ts-nocheck
/* tslint:disable */
/* eslint-disable */
/**
 * Humla Health API
 * Humla Health API
 *
 * The version of the OpenAPI document: 1.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.instanceOfRqiDataDto = instanceOfRqiDataDto;
exports.RqiDataDtoFromJSON = RqiDataDtoFromJSON;
exports.RqiDataDtoFromJSONTyped = RqiDataDtoFromJSONTyped;
exports.RqiDataDtoToJSON = RqiDataDtoToJSON;
exports.RqiDataDtoToJSONTyped = RqiDataDtoToJSONTyped;
/**
 * Check if a given object implements the RqiDataDto interface.
 */
function instanceOfRqiDataDto(value) {
    if (!('programName' in value) || value['programName'] === undefined)
        return false;
    if (!('certificateName' in value) || value['certificateName'] === undefined)
        return false;
    if (!('userName' in value) || value['userName'] === undefined)
        return false;
    if (!('email' in value) || value['email'] === undefined)
        return false;
    if (!('expirationDate' in value) || value['expirationDate'] === undefined)
        return false;
    if (!('id' in value) || value['id'] === undefined)
        return false;
    if (!('brandName' in value) || value['brandName'] === undefined)
        return false;
    if (!('attemptId' in value) || value['attemptId'] === undefined)
        return false;
    if (!('recommendedRenewalDate' in value) || value['recommendedRenewalDate'] === undefined)
        return false;
    if (!('certType' in value) || value['certType'] === undefined)
        return false;
    return true;
}
function RqiDataDtoFromJSON(json) {
    return RqiDataDtoFromJSONTyped(json, false);
}
function RqiDataDtoFromJSONTyped(json, ignoreDiscriminator) {
    if (json == null) {
        return json;
    }
    return {
        'programName': json['programName'],
        'certificateName': json['certificateName'],
        'userName': json['userName'],
        'email': json['email'],
        'expirationDate': json['expirationDate'],
        'id': json['id'],
        'brandName': json['brandName'],
        'courseCompletionDate': json['courseCompletionDate'] == null ? undefined : json['courseCompletionDate'],
        'attemptId': json['attemptId'],
        'recommendedRenewalDate': json['recommendedRenewalDate'],
        'certType': json['certType'],
    };
}
function RqiDataDtoToJSON(json) {
    return RqiDataDtoToJSONTyped(json, false);
}
function RqiDataDtoToJSONTyped(value, ignoreDiscriminator = false) {
    if (value == null) {
        return value;
    }
    return {
        'programName': value['programName'],
        'certificateName': value['certificateName'],
        'userName': value['userName'],
        'email': value['email'],
        'expirationDate': value['expirationDate'],
        'id': value['id'],
        'brandName': value['brandName'],
        'courseCompletionDate': value['courseCompletionDate'],
        'attemptId': value['attemptId'],
        'recommendedRenewalDate': value['recommendedRenewalDate'],
        'certType': value['certType'],
    };
}
//# sourceMappingURL=RqiDataDto.js.map